import React, { useState, useEffect } from 'react';
import { Card, Form, Input, InputNumber, Button, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { calculateTotalSurface } from '../../../Utils/exploitations/exploitations';
import './disabled_input.css';

const ValveForm = ({ onSubmit, onCancel, exploitationId }) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const [kmlFiles, setKmlFiles] = useState([]);
  const [brutSurface, setBrutSurface] = useState(0);

  useEffect(() => {
    const calculateBrutSurface = async () => {
      if (kmlFiles.length > 0) {
        try {
          const surface = await calculateTotalSurface(kmlFiles.map(file => file.originFileObj));
          setBrutSurface(surface);
          form.setFieldsValue({ valve_superficie_brut: surface });
        } catch (error) {
          console.error('Error calculating surface:', error);
          message.error('Erreur lors du calcul de la surface brute');
        }
      }
    };
    calculateBrutSurface();
  }, [kmlFiles, form]);

  const calculateFlow = (changedvalues) => {
    if (changedvalues.hasOwnProperty('valve_superficie_brut')) {
      setBrutSurface(changedvalues.valve_superficie_brut);
    }
    const { valve_superficie_net, pluviometry } = form.getFieldsValue(['valve_superficie_net', 'pluviometry']);
    if (valve_superficie_net && pluviometry) {
      const flow = valve_superficie_net * pluviometry;
      form.setFieldsValue({ flow: parseFloat(flow.toFixed(2)) });
    } else {
      form.setFieldsValue({ flow: null });
    }
    form.validateFields(['valve_superficie_net', 'pluviometry', 'flow', 'valve_superficie_brut']);
  };

  
  const handleSubmit = async (values) => {
    setSubmitting(true);
    try {
      const formData = new FormData();
      Object.keys(values).forEach(key => {
        if (key !== 'files') {
          formData.append(key, values[key]);
        }
      });
      formData.append('exploitation_id', exploitationId);
      kmlFiles.forEach(file => {
        formData.append('files', file.originFileObj);
      });

      await onSubmit(formData);
      form.resetFields();
      setKmlFiles([]);
    } catch (error) {
      console.error('Error submitting form:', error);
      message.error('Erreur lors de la création de la vanne');
    } finally {
      setSubmitting(false);
    }
  };

  const handleFileChange = ({ fileList }) => {
    const validFiles = fileList.filter(file => file.type === 'application/vnd.google-earth.kml+xml' || file.name.endsWith('.kml'));

    if (validFiles.length !== fileList.length) {
      message.warning('Seuls les fichiers KML sont autorisés.');
    }

    setKmlFiles(validFiles);
  };

  return (
    <Card
      title="Nouvelle vanne"
      className='bg-indigo-50 w-80 mb-4'
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={handleSubmit}
        onValuesChange={calculateFlow}
      >
        <Form.Item
          name="valve_name"
          label="Nom"
          rules={[{ required: true, message: 'Veuillez entrer le nom de la vanne' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="valve_superficie_brut" label="Superficie brute (ha)" >
          <InputNumber min={0} style={{ width: '100%' }}  />
        </Form.Item>
        <Form.Item
          name="valve_superficie_net"
          label="Superficie nette (ha)"
          rules={[
            { required: true, message: 'Veuillez entrer la superficie nette' },
            {
              validator: (_, value) =>
                value <= form.getFieldValue('valve_superficie_brut')
                  ? Promise.resolve()
                  : Promise.reject('La superficie nette doit être inférieure ou égale à la superficie brute')
            }
          ]}
        >
          <InputNumber min={0} style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item
          name="culture"
          label="Culture"
>
          <Input />
        </Form.Item>
        <Form.Item
          name="variety"
          label="Variété"
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="plantation_density"
          label="Densité de plantation"
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="line"
          label="Ligne"
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="foot"
          label="Pied"
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="pluviometry"
          label="Pluviométrie (m³/h/Ha)"
          rules={[{ required: true, message: 'Veuillez entrer la pluviométrie' }]}
        >
          <InputNumber min={0} style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          name="flow"
          label="Débit (m³/h)"
          className="mb-4"
        >
          <InputNumber
            disabled
            className="w-full custom-disabled-input"
          />
        </Form.Item>
        <Form.Item name="files" label="Fichiers KML">
          <Upload
            accept=".kml"
            multiple={true}
            fileList={kmlFiles}
            onChange={handleFileChange}
            beforeUpload={() => false}
          >
            <Button icon={<UploadOutlined />}>Ajouter des fichiers KML</Button>
          </Upload>
        </Form.Item>
        <Form.Item className='text-right'>
          <Button onClick={onCancel} style={{ marginRight: 8 }}>
            Annuler
          </Button>
          <Button type="primary" htmlType="submit" loading={submitting}>
            Créer
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default ValveForm;